module.exports = __webpack_public_path__ + "static/media/collaborator_icon_color.b1272862.png";